module.exports = __webpack_public_path__ + "img/Moon and Stairs Mystical Logo Template (6).0c1b3ef8.png";